// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"422d9407","143":"3e35d83b","196":"b5e71974","224":"e9cb547d","254":"35156013","596":"f063ff25","778":"08b0881b"}[chunkId] + ".chunk.js";
};